// extracted by mini-css-extract-plugin
export default {"revision_gutter-right":"revisions_revision_gutter-right__0F9Ps","revision_line-change-indicator":"revisions_revision_line-change-indicator__UjfhC"};